import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "checkbox check-gdpr no-form-style" }
const _hoisted_2 = ["disabled"]

import {useStore} from "vuex";
import {ref, watch} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GdprCheckbox',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const store = useStore()
const checked = ref<boolean>(props.modelValue)

watch(checked, () => emit('update:modelValue', checked.value))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checked).value = $event)),
      disabled: _unref(store).state.configuration,
      required: ""
    }, null, 8, _hoisted_2), [
      [_vModelCheckbox, checked.value]
    ]),
    _createTextVNode(" Ich erteile die Zustimmung ")
  ]))
}
}

})